
import Container from '~/components/layout/Container'
import NewsItem from '~/components/news/NewsItem'
import { NEWS } from '~/constants/api'

export default {
    async asyncData({ $axios, params }) {
        const res = await $axios.get(`${NEWS}/${params.id}`)
        return { 
            news: res.data.item,
        }
    },
    data() {
        return {
            news: null,
        }
    },
    computed: {
        date() {
            if (this.news.created_at) {
                let date = new Date(this.news.created_at)
                return date.toLocaleDateString(this.$i18n.localeProperties.iso)
            }
            return ''
        },
        image() {
            return this.news.images.find(el => el.format === 'original')
        }
    },
    methods: {
        recommendedColor(i) {
            switch (i) {
                case 0:
                    return 'yellow'
                case 1:
                    return 'gray'
                case 2:
                    return 'dark'
                default:
                    return 'yellow'
            }
        }
    },
    components: {
        Container,
        NewsItem
    }    
}
